"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigNum = require("@liskhq/bignum");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var base_transaction_1 = require("./base_transaction");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var response_1 = require("./response");

var utils_1 = require("./utils");

exports.multisignatureAssetFormatSchema = {
  type: 'object',
  required: ['multisignature'],
  properties: {
    multisignature: {
      type: 'object',
      required: ['min', 'lifetime', 'keysgroup'],
      properties: {
        min: {
          type: 'integer',
          minimum: 1,
          maximum: 15
        },
        lifetime: {
          type: 'integer',
          minimum: 1,
          maximum: 72
        },
        keysgroup: {
          type: 'array',
          uniqueItems: true,
          minItems: 1,
          maxItems: 15,
          items: {
            type: 'string',
            format: 'additionPublicKey'
          }
        }
      }
    }
  }
};

var setMemberAccounts = function setMemberAccounts(store, membersPublicKeys) {
  membersPublicKeys.forEach(function (memberPublicKey) {
    var address = lisk_cryptography_1.getAddressFromPublicKey(memberPublicKey);
    var memberAccount = store.account.getOrDefault(address);
    var memberAccountWithPublicKey = Object.assign({}, memberAccount, {
      publicKey: memberAccount.publicKey || memberPublicKey
    });
    store.account.set(memberAccount.address, memberAccountWithPublicKey);
  });
};

var extractPublicKeysFromAsset = function extractPublicKeysFromAsset(assetPublicKeys) {
  return assetPublicKeys.map(function (key) {
    return key.substring(1);
  });
};

var MultisignatureTransaction =
/*#__PURE__*/
function (_base_transaction_1$B) {
  _inherits(MultisignatureTransaction, _base_transaction_1$B);

  function MultisignatureTransaction(rawTransaction) {
    var _this;

    _classCallCheck(this, MultisignatureTransaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultisignatureTransaction).call(this, rawTransaction));
    _this._multisignatureStatus = base_transaction_1.MultisignatureStatus.PENDING;
    var tx = typeof rawTransaction === 'object' && rawTransaction !== null ? rawTransaction : {};
    _this.asset = tx.asset || {
      multisignature: {}
    };
    return _this;
  }

  _createClass(MultisignatureTransaction, [{
    key: "assetToBytes",
    value: function assetToBytes() {
      var _this$asset$multisign = this.asset.multisignature,
          min = _this$asset$multisign.min,
          lifetime = _this$asset$multisign.lifetime,
          keysgroup = _this$asset$multisign.keysgroup;
      var minBuffer = Buffer.alloc(1, min);
      var lifetimeBuffer = Buffer.alloc(1, lifetime);
      var keysgroupBuffer = Buffer.from(keysgroup.join(''), 'utf8');
      return Buffer.concat([minBuffer, lifetimeBuffer, keysgroupBuffer]);
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(store) {
        var membersAddresses;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                membersAddresses = extractPublicKeysFromAsset(this.asset.multisignature.keysgroup).map(function (publicKey) {
                  return {
                    address: lisk_cryptography_1.getAddressFromPublicKey(publicKey)
                  };
                });
                _context.next = 3;
                return store.account.cache([{
                  address: this.senderId
                }].concat(_toConsumableArray(membersAddresses)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "verifyAgainstTransactions",
    value: function verifyAgainstTransactions(transactions) {
      var _this2 = this;

      var errors = transactions.filter(function (tx) {
        return tx.type === _this2.type && tx.senderPublicKey === _this2.senderPublicKey;
      }).map(function (tx) {
        return new errors_1.TransactionError('Register multisignature only allowed once per account.', tx.id, '.asset.multisignature');
      });
      return errors;
    }
  }, {
    key: "validateAsset",
    value: function validateAsset() {
      utils_1.validator.validate(exports.multisignatureAssetFormatSchema, this.asset);
      var errors = errors_1.convertToAssetError(this.id, utils_1.validator.errors);

      if (!this.amount.eq(0)) {
        errors.push(new errors_1.TransactionError('Amount must be zero for multisignature registration transaction', this.id, '.amount', this.amount.toString(), '0'));
      }

      if (errors.length > 0) {
        return errors;
      }

      if (this.asset.multisignature.min > this.asset.multisignature.keysgroup.length) {
        errors.push(new errors_1.TransactionError('Invalid multisignature min. Must be less than or equal to keysgroup size', this.id, '.asset.multisignature.min', this.asset.multisignature.min));
      }

      if (this.recipientId) {
        errors.push(new errors_1.TransactionError('RecipientId is expected to be undefined', this.id, '.recipientId', this.recipientId));
      }

      if (this.recipientPublicKey) {
        errors.push(new errors_1.TransactionError('RecipientPublicKey is expected to be undefined', this.id, '.recipientPublicKey', this.recipientPublicKey));
      }

      return errors;
    }
  }, {
    key: "validateFee",
    value: function validateFee() {
      var expectedFee = new BigNum(MultisignatureTransaction.FEE).mul(this.asset.multisignature.keysgroup.length + 1);
      return !this.fee.eq(expectedFee) ? new errors_1.TransactionError("Fee must be equal to ".concat(expectedFee.toString()), this.id, '.fee', this.fee.toString(), expectedFee.toString()) : undefined;
    }
  }, {
    key: "processMultisignatures",
    value: function processMultisignatures(_) {
      var transactionBytes = this.getBasicBytes();

      var _utils_1$validateMult = utils_1.validateMultisignatures(this.asset.multisignature.keysgroup.map(function (signedPublicKey) {
        return signedPublicKey.substring(1);
      }), this.signatures, this.asset.multisignature.keysgroup.length, transactionBytes, this.id),
          valid = _utils_1$validateMult.valid,
          errors = _utils_1$validateMult.errors;

      if (valid) {
        this._multisignatureStatus = base_transaction_1.MultisignatureStatus.READY;
        return response_1.createResponse(this.id, errors);
      }

      if (errors && errors.length === 1 && errors[0] instanceof errors_1.TransactionPendingError) {
        this._multisignatureStatus = base_transaction_1.MultisignatureStatus.PENDING;
        return {
          id: this.id,
          status: response_1.Status.PENDING,
          errors: errors
        };
      }

      this._multisignatureStatus = base_transaction_1.MultisignatureStatus.FAIL;
      return response_1.createResponse(this.id, errors);
    }
  }, {
    key: "applyAsset",
    value: function applyAsset(store) {
      var errors = [];
      var sender = store.account.get(this.senderId);

      if (sender.membersPublicKeys && sender.membersPublicKeys.length > 0) {
        errors.push(new errors_1.TransactionError('Register multisignature only allowed once per account.', this.id, '.signatures'));
      }

      if (this.asset.multisignature.keysgroup.includes("+".concat(sender.publicKey))) {
        errors.push(new errors_1.TransactionError('Invalid multisignature keysgroup. Can not contain sender', this.id, '.signatures'));
      }

      var updatedSender = Object.assign({}, sender, {
        membersPublicKeys: extractPublicKeysFromAsset(this.asset.multisignature.keysgroup),
        multiMin: this.asset.multisignature.min,
        multiLifetime: this.asset.multisignature.lifetime
      });
      store.account.set(updatedSender.address, updatedSender);
      setMemberAccounts(store, updatedSender.membersPublicKeys);
      return errors;
    }
  }, {
    key: "undoAsset",
    value: function undoAsset(store) {
      var sender = store.account.get(this.senderId);
      var resetSender = Object.assign({}, sender, {
        membersPublicKeys: [],
        multiMin: 0,
        multiLifetime: 0
      });
      store.account.set(resetSender.address, resetSender);
      return [];
    }
  }, {
    key: "addMultisignature",
    value: function addMultisignature(store, signatureObject) {
      var keysgroup = this.asset.multisignature.keysgroup.map(function (aKey) {
        return aKey.slice(1);
      });

      if (!keysgroup.includes(signatureObject.publicKey)) {
        return response_1.createResponse(this.id, [new errors_1.TransactionError("Public Key '".concat(signatureObject.publicKey, "' is not a member."), this.id)]);
      }

      if (this.signatures.includes(signatureObject.signature)) {
        return response_1.createResponse(this.id, [new errors_1.TransactionError('Encountered duplicate signature in transaction', this.id)]);
      }

      var _utils_1$validateSign = utils_1.validateSignature(signatureObject.publicKey, signatureObject.signature, this.getBasicBytes(), this.id),
          valid = _utils_1$validateSign.valid;

      if (valid) {
        this.signatures.push(signatureObject.signature);
        return this.processMultisignatures(store);
      }

      var errors = valid ? [] : [new errors_1.TransactionError("Failed to add signature ".concat(signatureObject.signature, "."), this.id, '.signatures')];
      return response_1.createResponse(this.id, errors);
    }
  }, {
    key: "assetFromSync",
    value: function assetFromSync(raw) {
      if (!raw.m_keysgroup) {
        return undefined;
      }

      var multisignature = {
        min: raw.m_min,
        lifetime: raw.m_lifetime,
        keysgroup: typeof raw.m_keysgroup === 'string' ? raw.m_keysgroup.split(',') : raw.m_keysgroup
      };
      return {
        multisignature: multisignature
      };
    }
  }]);

  return MultisignatureTransaction;
}(base_transaction_1.BaseTransaction);

MultisignatureTransaction.TYPE = 4;
MultisignatureTransaction.FEE = constants_1.MULTISIGNATURE_FEE.toString();
exports.MultisignatureTransaction = MultisignatureTransaction;